import React, { Component } from 'react';
import ReactExport from "react-export-excel-xlsx-fix";
import { ImportExport } from "@mui/icons-material";
import moment from "moment";
import Global from "../../customlib/Global";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class ExportCheckPointSummaryReport extends Component {

    getleadsReportData = () => {
        let leadsData = [];
        this.props.leadsReportData.forEach(element => {
            leadsData.push(element);
        });
        console.log("EXPORTDATA", leadsData);
        return leadsData;
    }

    state = {  }
    render() { 
        return (
            <ExcelFile element={<button className="btn btn-primary"><ImportExport />Download Summary</button>}>
            {/* <ExcelFile> */}
                <ExcelSheet data={this.getleadsReportData} name="Check Point Summary Report">
                    <ExcelColumn label="Nama" value="userName"/>
                    <ExcelColumn label="Role" value="role"/>
                    <ExcelColumn label="Platform" value="platform"/>
                    <ExcelColumn label="Tanggal" value="dateFormatted"/>
                    <ExcelColumn label="Shift" value="shift"/>
                    <ExcelColumn label="Jumlah CP" value="successCount"/>
                    <ExcelColumn label="% CP" value="rate"/>
                    {/* <ExcelColumn label="Check In"
                                  value={(col) => col.checkPointSucceeded === true ? "Succeed" : "Failed"}/>
                    <ExcelColumn label="Date Time"
                                  value={(col) => Global.formatDateTimeToStrDateTime24(col.checkedAt)}/> */}
                    
                </ExcelSheet>
            </ExcelFile>
        );
    }
}
 
export default ExportCheckPointSummaryReport;